// src/oura/newscan/firstCheckLinks.ts
//
// Where a signed client's First AI check lives (JOURNEY-SPEC v1.1 §2.5): the
// draft flow on the business, `?purpose=first_check`, and the onboarding page
// every exit returns to. One copy, so the onboarding Next card, the step row
// and the business page open the flow the same way.
//
//   firstCheckHref(id)                          opens (or drafts) the check: Review, or Start once approved
//   firstCheckHref(id, { draftId, step })       a known draft at a step ("start" when approved)
//   onboardingHref(id)                          the onboarding page

import { OURA_ROOT } from "@oura/nav";

export function onboardingHref(businessId: string): string {
    return `${OURA_ROOT}/businesses/${encodeURIComponent(businessId)}/onboarding`;
}

export function firstCheckHref(businessId: string, opts?: { draftId?: string | null; step?: "review" | "start" | null }): string {
    const params = new URLSearchParams({ purpose: "first_check" });
    if (opts?.draftId) params.set("draft", opts.draftId);
    if (opts?.step) params.set("step", opts.step);
    return `${OURA_ROOT}/businesses/${encodeURIComponent(businessId)}/questions/draft?${params.toString()}`;
}
